import { AnyAction } from '@reduxjs/toolkit'

import { FETCH_ROLES_SUCCESS } from '@/components/App/actionTypes'

type RolesState = {
  byId: Record<string, { id: string; name: string }>
}

const initialState: RolesState = { byId: {} }

export default function rolesReducer(state = initialState, action: AnyAction): RolesState {
  switch (action.type) {
    case FETCH_ROLES_SUCCESS: {
      if (action.response) {
        const byIdMap: RolesState['byId'] = {}
        action.response.forEach((role: { id: string; name: string }) => {
          byIdMap[role.id] = role
        })

        return {
          byId: byIdMap
        }
      } else {
        return {
          byId: {}
        }
      }
    }
    default: {
      return state
    }
  }
}
